module.exports = __webpack_public_path__ + "img/A3-2-plan.581252f0.png";